module.exports = __webpack_public_path__ + "static/media/pressNxtBtn.62314981.svg";